<template>
  <div id="app" style="background:rgb(236, 236, 236);height:100%">
   <!-- <frontendHeader></frontendHeader> -->
    <router-view/>
    <!--  <frontendFooter></frontendFooter> -->
  </div>
</template>



<script>
  // import frontendHeader from '@/components/header.vue'
  // import frontendFooter from '@/components/footer.vue'

  export default {
    data() {
      return {
        //img: Img
      }
    },
    name: 'App',
    // components: {
    //   'frontendHeader': frontendHeader,
    //   'frontendFooter': frontendFooter
    // }
  }
</script>

<style>

  /*以下是页面项目公用初始化样式*/
  html, body, div,  applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption,  hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-size: 14px;
  }

  .el-dialog__header{
    text-align: left;
  }
  .el-table th{
    background-color: #ecf5ff
  }
  .el-dialog{
    width: 70%;
  }
  .el-form-item {
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .el-form-item input{
    height:30px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .input-width {
    width:202px;
    height:30px;
  }

  .themeColor{
    background-color: #2180d1;
  }

  .fontColor{
    color: white;
  }

  .el-dialog__header {
    text-align: left;
    background-color: #2180d1;
    color: white;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: white;
  }

  .el-dialog__headerbtn {
    position: absolute;
    top: 15px;
    right: 20px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
    color: white;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: white;
  }

  .el-table th, .el-table tr {
    background-color: #FFF;
    cursor: pointer;
  }

  .el-button--small, .el-button--small.is-round {
    padding: 7px 13px;
  }

  .el-button--small {
    font-size: 15px;
    border-radius: 3px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue